import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { FiCheck, FiCircle } from 'react-icons/fi';

const SetupChecklist = ({ projectId, stats }) => {
  const navigate = useNavigate();

  const required = [
    { label: 'Add modules', isComplete: stats.modulesCount > 0, path: 'modules' },
  ];

  const optional = [
    { label: 'Add screener questions', isComplete: stats.screenersCount > 0, path: 'screener' },
    { label: 'Set recruitment targets', isComplete: stats.targetsComplete, path: 'screener' },
  ];

  const renderItem = (item, idx) => (
    <button
      key={idx}
      onClick={(e) => { e.stopPropagation(); navigate(`/projects/${projectId}/${item.path}`); }}
      className={`w-full flex items-center justify-between p-2.5 rounded-md transition-all border ${
        item.isComplete
          ? 'bg-emerald-50/30 border-emerald-100 text-emerald-700'
          : 'bg-white border-gray-100 text-gray-500 hover:border-rutabaga-pink/30 hover:bg-gray-50'
      }`}
    >
      <span className="text-xs font-bold">{item.label}</span>
      <SafeIcon icon={item.isComplete ? FiCheck : FiCircle} className={item.isComplete ? 'text-emerald-500' : 'text-gray-300'} />
    </button>
  );

  return (
    <div className="py-2 space-y-4">
      {/* Required */}
      <div>
        <div className="flex items-center gap-2 mb-2">
          <span className="text-[10px] font-black text-rutabaga-pink uppercase tracking-widest">Required</span>
          <div className="flex-1 h-[1px] bg-gray-100" />
        </div>
        <div className="space-y-2">{required.map(renderItem)}</div>
      </div>

      {/* Optional */}
      <div>
        <div className="flex items-center gap-2 mb-2">
          <span className="text-[10px] font-black text-gray-300 uppercase tracking-widest">Optional</span>
          <div className="flex-1 h-[1px] bg-gray-100" />
        </div>
        <div className="space-y-2">{optional.map(renderItem)}</div>
      </div>
    </div>
  );
};

export default SetupChecklist;